module.exports = __webpack_public_path__ + "static/media/20191214_160645.01125271.jpg";